"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FluidI18nLookups = exports.getFluidLanguageForm = exports.getFluidLocale = void 0;
const locale_1 = require("date-fns/locale");
const enums_1 = require("../../structs/enums");
const fluidLanguageLookup = (language = enums_1.FluidLanguage.ENGLISH) => {
    switch (language) {
        case enums_1.FluidLanguage.ENGLISH: return Object.assign({ longForm: 'English' }, getFluidLocale(enums_1.FluidLocale.UNITED_STATES));
        case enums_1.FluidLanguage.FRENCH: return Object.assign({ longForm: 'French' }, getFluidLocale(enums_1.FluidLocale.FRANCE));
        case enums_1.FluidLanguage.SPANISH: return Object.assign({ longForm: 'Spanish' }, getFluidLocale(enums_1.FluidLocale.SPAIN));
        case enums_1.FluidLanguage.ITALIAN: return Object.assign({ longForm: 'Italian' }, getFluidLocale(enums_1.FluidLocale.ITALY));
        case enums_1.FluidLanguage.GERMAN: return Object.assign({ longForm: 'German' }, getFluidLocale(enums_1.FluidLocale.GERMANY));
        case enums_1.FluidLanguage.JAPANESE: return Object.assign({ longForm: 'Japanese' }, getFluidLocale(enums_1.FluidLocale.JAPAN));
        case enums_1.FluidLanguage.PORTUGUESE: return Object.assign({ longForm: 'Portuguese' }, getFluidLocale(enums_1.FluidLocale.PORTUGAL));
        default: {
            console.warn(`${language} not currently supported - return US English as default`);
            return Object.assign({ longForm: 'English' }, fluidLocales[enums_1.FluidLocale.UNITED_STATES]);
        }
    }
};
const fluidLocales = {
    [enums_1.FluidLocale.UNITED_STATES]: {
        countryCode: enums_1.FluidLocale.UNITED_STATES,
        currencyCode: "USD",
        numberFormat: 'en-US',
        localeCode: "en-US",
        dateFormat: "MM/dd/yyyy",
        dateLocale: locale_1.enUS,
        timeFormat: "hh:mm a",
        defaultLanguage: enums_1.FluidLanguage.ENGLISH,
        textDirection: 'ltr',
        flag: enums_1.FluidIconKey.USA
    },
    [enums_1.FluidLocale.UNITED_KINGDOM]: {
        countryCode: enums_1.FluidLocale.UNITED_KINGDOM,
        currencyCode: "GBP",
        numberFormat: 'en-GB',
        localeCode: "en-GB",
        dateFormat: "dd/MM/yyyy",
        dateLocale: locale_1.enGB,
        timeFormat: "HH:mm",
        defaultLanguage: enums_1.FluidLanguage.ENGLISH,
        textDirection: 'ltr',
        flag: enums_1.FluidIconKey.UNITED_KINGDOM
    },
    [enums_1.FluidLocale.CANADA]: {
        countryCode: enums_1.FluidLocale.CANADA,
        currencyCode: "CAD",
        numberFormat: 'en-CA',
        localeCode: "en-CA",
        dateFormat: "yyyy-MM-dd",
        dateLocale: locale_1.enCA,
        timeFormat: "h:mm a",
        defaultLanguage: enums_1.FluidLanguage.ENGLISH,
        textDirection: 'ltr',
        flag: enums_1.FluidIconKey.CANADA
    },
    [enums_1.FluidLocale.AUSTRALIA]: {
        countryCode: enums_1.FluidLocale.AUSTRALIA,
        currencyCode: "AUD",
        numberFormat: 'en-AU',
        localeCode: "en-AU",
        dateFormat: "dd/MM/yyyy",
        dateLocale: locale_1.enAU,
        timeFormat: "h:mm a",
        defaultLanguage: enums_1.FluidLanguage.ENGLISH,
        textDirection: 'ltr',
        flag: enums_1.FluidIconKey.AUSTRALIA
    },
    [enums_1.FluidLocale.FRANCE]: {
        countryCode: enums_1.FluidLocale.FRANCE,
        currencyCode: "EUR",
        numberFormat: 'fr-FR',
        localeCode: "fr-FR",
        dateFormat: "dd/MM/yyyy",
        dateLocale: locale_1.fr,
        timeFormat: "HH:mm",
        defaultLanguage: enums_1.FluidLanguage.FRENCH,
        textDirection: 'ltr',
        flag: enums_1.FluidIconKey.FRANCE
    },
    [enums_1.FluidLocale.GERMANY]: {
        countryCode: enums_1.FluidLocale.GERMANY,
        currencyCode: "EUR",
        numberFormat: 'de-DE',
        localeCode: "de-DE",
        dateFormat: "dd.MM.yyyy",
        dateLocale: locale_1.de,
        timeFormat: "HH:mm",
        defaultLanguage: enums_1.FluidLanguage.GERMAN,
        textDirection: 'ltr',
        flag: enums_1.FluidIconKey.GERMANY
    },
    [enums_1.FluidLocale.SPAIN]: {
        countryCode: enums_1.FluidLocale.SPAIN,
        currencyCode: "EUR",
        numberFormat: 'es-ES',
        localeCode: "es-ES",
        dateFormat: "dd/MM/yyyy",
        dateLocale: locale_1.es,
        timeFormat: "HH:mm",
        defaultLanguage: enums_1.FluidLanguage.SPANISH,
        textDirection: 'ltr',
        flag: enums_1.FluidIconKey.SPAIN
    },
    [enums_1.FluidLocale.ITALY]: {
        countryCode: enums_1.FluidLocale.ITALY,
        currencyCode: "EUR",
        numberFormat: 'it-IT',
        localeCode: "it-IT",
        dateFormat: "dd/MM/yyyy",
        dateLocale: locale_1.it,
        timeFormat: "HH:mm",
        defaultLanguage: enums_1.FluidLanguage.ITALIAN,
        textDirection: 'ltr',
        flag: enums_1.FluidIconKey.ITALY
    },
    [enums_1.FluidLocale.BRAZIL]: {
        countryCode: enums_1.FluidLocale.BRAZIL,
        currencyCode: "BRL",
        numberFormat: 'pt-BR',
        localeCode: "pt-BR",
        dateFormat: "dd/MM/yyyy",
        dateLocale: locale_1.ptBR,
        timeFormat: "HH:mm",
        defaultLanguage: enums_1.FluidLanguage.PORTUGUESE,
        textDirection: 'ltr',
        flag: enums_1.FluidIconKey.BRAZIL
    },
    [enums_1.FluidLocale.JAPAN]: {
        countryCode: enums_1.FluidLocale.JAPAN,
        currencyCode: "JPY",
        localeCode: "ja-JP",
        numberFormat: 'ja-JP',
        dateFormat: "yyyy/MM/dd",
        dateLocale: locale_1.ja,
        timeFormat: "H:mm",
        defaultLanguage: enums_1.FluidLanguage.JAPANESE,
        textDirection: 'ltr',
        flag: enums_1.FluidIconKey.JAPAN
    },
    [enums_1.FluidLocale.MEXICO]: {
        countryCode: enums_1.FluidLocale.MEXICO,
        currencyCode: "MXN",
        numberFormat: 'es-MX',
        localeCode: "es-MX",
        dateFormat: "dd/mm/yyyy",
        dateLocale: locale_1.es,
        timeFormat: "HH:mm",
        defaultLanguage: enums_1.FluidLanguage.SPANISH,
        textDirection: 'ltr',
        flag: enums_1.FluidIconKey.MEXICO
    },
    [enums_1.FluidLocale.BELGIUM]: {
        countryCode: enums_1.FluidLocale.BELGIUM,
        currencyCode: "EUR",
        numberFormat: 'nl-BE',
        localeCode: "fr-BE",
        dateFormat: "dd/mm/yyyy",
        dateLocale: locale_1.nlBE,
        timeFormat: "HH:mm",
        defaultLanguage: enums_1.FluidLanguage.FRENCH,
        textDirection: 'ltr',
        flag: enums_1.FluidIconKey.BELGIUM
    },
    [enums_1.FluidLocale.PERU]: {
        countryCode: enums_1.FluidLocale.PERU,
        currencyCode: "PEN",
        numberFormat: 'es-PE',
        localeCode: "es-PE",
        dateFormat: "dd/mm/yyyy",
        dateLocale: locale_1.es,
        timeFormat: "HH:mm",
        defaultLanguage: enums_1.FluidLanguage.SPANISH,
        textDirection: 'ltr',
        flag: enums_1.FluidIconKey.PERU
    },
    [enums_1.FluidLocale.CHILE]: {
        countryCode: enums_1.FluidLocale.CHILE,
        currencyCode: "CLP",
        numberFormat: 'es-CL',
        localeCode: "es-CL",
        dateFormat: "dd/mm/yyyy",
        dateLocale: locale_1.es,
        timeFormat: "HH:mm",
        defaultLanguage: enums_1.FluidLanguage.SPANISH,
        textDirection: 'ltr',
        flag: enums_1.FluidIconKey.CHILE
    },
    [enums_1.FluidLocale.PORTUGAL]: {
        countryCode: enums_1.FluidLocale.PORTUGAL,
        currencyCode: "EUR",
        numberFormat: 'pt-PT',
        localeCode: "pt-PT",
        dateFormat: "dd/mm/yyyy",
        dateLocale: locale_1.pt,
        timeFormat: "HH:mm",
        defaultLanguage: enums_1.FluidLanguage.PORTUGUESE,
        textDirection: 'ltr',
        flag: enums_1.FluidIconKey.PORTUGAL
    },
};
/**
 * Finds the full localisation information set for the given locale.
 * If not a currently supported locale, return US localisation and throw console warning.
 * @param locale
 */
function getFluidLocale(locale) {
    if (!fluidLocales[locale]) {
        console.warn(`${locale} is not currently a supported locale - returning ${enums_1.FluidLocale.UNITED_STATES} as default.`);
        return fluidLocales[enums_1.FluidLocale.UNITED_STATES];
    }
    return fluidLocales[locale];
}
exports.getFluidLocale = getFluidLocale;
/**
 * Returns long-form language information for the given language.
 * If not a currently supported language, return US language longform and throw console warning.
 * @param language
 */
function getFluidLanguageForm(language) { return fluidLanguageLookup(language); }
exports.getFluidLanguageForm = getFluidLanguageForm;
exports.FluidI18nLookups = {
    getFluidLocale,
    getFluidLanguageForm
};
